import type { WalkthroughEvent } from '@shared-types/frontend-scenario-definition';

export const participantViewWalkthrough: WalkthroughEvent = {
    key: 'participant-view-walkthrough',
    showAt: 'start',
    steps: [
        {
            id: '0',
            element: { selector: '[data-tour=dashboard]' },
            position: 'right',
            text: 'app.platformTour.dashboard',
        },
        {
            id: '1',
            element: { selector: '[data-tour=modules]' },
            text: 'app.platformTour.modules',
        },
        {
            id: '2',
            element: { selector: '[data-tour=reports-and-analytics]' },
            text: 'app.platformTour.reportsAndAnalytics',
        },
        {
            id: '3',
            element: { selector: '[data-tour=profile-settings]' },
            text: 'app.platformTour.profileSettings',
        },
        {
            id: '4',
            element: { selector: '[data-tour=notifications]' },
            text: 'app.platformTour.notifications',
        },
        {
            id: '5',
            element: { selector: '[data-tour=display-settings]' },
            text: 'app.platformTour.displaySettings',
        },
    ],
};

export default participantViewWalkthrough;
